export type Consumer<T> = (value: T) => any;
export interface Subscription {
  unsubscribe(): void;
}
export interface Publisher<T> {
  subscribe(consumer: Consumer<T>): Subscription;
}

export class Emitter<T> implements Publisher<T> {
  private consumers: Map<symbol, Consumer<T>>;
  constructor() {
    this.consumers = new Map<symbol, Consumer<T>>();
  }
  get size(): number {
    return this.consumers.size;
  }
  subscribe(consumer: Consumer<T>): Subscription {
    const consumerKey = Symbol();
    this.consumers.set(consumerKey, consumer);
    return {
      unsubscribe: () => this.consumers.delete(consumerKey),
    };
  }
  emit(value: T) {
    if (this.consumers.size === 0) {
      return;
    }
    this.consumers.forEach((consumer) => consumer(value));
  }
  clear() {
    this.consumers.clear();
    this.consumers = new Map<symbol, Consumer<T>>();
  }
}
